export default "__VITE_ASSET__90bd9e5a__"